/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cm: NonNullable<unknown> }} Profile_Height_ValueInputs */

const en_us2_profile_height_value = /** @type {(inputs: Profile_Height_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const pt_br2_profile_height_value = /** @type {(inputs: Profile_Height_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const es_419_profile_height_value = /** @type {(inputs: Profile_Height_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const pt_pt2_profile_height_value = /** @type {(inputs: Profile_Height_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const fr_fr2_profile_height_value = /** @type {(inputs: Profile_Height_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const de_de2_profile_height_value = /** @type {(inputs: Profile_Height_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const it_it2_profile_height_value = /** @type {(inputs: Profile_Height_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

/**
* | output |
* | --- |
* | "{cm} cm" |
*
* @param {Profile_Height_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_height_value = /** @type {((inputs: Profile_Height_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Height_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_height_value(inputs)
	if (locale === "es-419") return es_419_profile_height_value(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_height_value(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_height_value(inputs)
	if (locale === "de-DE") return de_de2_profile_height_value(inputs)
	if (locale === "it-IT") return it_it2_profile_height_value(inputs)
	return en_us2_profile_height_value(inputs)
});
export { profile_height_value as "profile.height_value" }